<template>
  <date-picker
    inline
    type="datetime"
    valueType="format"
    :format="showTimeSecond ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY HH:mm'"
    :lang="lang"
    :value="value"
    :show-second="showTimeSecond"
    :confirm="showConfirm"
    @confirm="onConfirm"
    @input="updateValue"
    @change="onChange"
  >
  </date-picker>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import 'vue2-datepicker/locale/th'

export default {
  components: {
    DatePicker,
  },

  props: {
    value: {
      type: [Date, String],
    },

    showTimeSecond: {
      type: Boolean,
      default: false,
    },

    lang: {
      type: String,
      default: 'th',
    },

    showConfirm: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onConfirm() {
      this.$emit('onConfirm')
    },

    updateValue(value) {
      this.$emit('input', value)
    },

    onChange(value, type) {
      this.$emit('onChange', type)
    },
  },
}
</script>
